// extracted by mini-css-extract-plugin
module.exports =  {"header":"_93444fe79c--header--AkTGE","heart":"_93444fe79c--heart--PSDxx","body":"_93444fe79c--body--HBy2Z","close":"_93444fe79c--close--zDnoL"};